<template>
  <div>
    <van-nav-bar
      :title="$t('app.deal_inquiry.title')"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <div class="topContent" style="font-size: 14px">
      <van-row class="dateFilter"
        ><van-col span="4" class="rowStyle"><span>{{$t("app.deal_inquiry.date")}}</span></van-col>
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="startDate"
              @click="startStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="startStatus" position="bottom">
              <van-datetime-picker
                style="color: red"
                v-model="date"
                @confirm="onConfirmStartDate"
                @cancel="startStatus = false"
                :cancel-button-text="$t('app.common.cancel')"
                :confirm-button-text="$t('app.common.confirm')"
                type="date"
                :title="$t('app.deal_inquiry.select_date')"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="1" class="rowStyle" style="text-align: center"
          ><span>--</span></van-col
        >
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="endDate"
              @click="endStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="endStatus" position="bottom">
              <van-datetime-picker
                v-model="date"
                @confirm="onConfirmEndDate"
                @cancel="endStatus = false"
                :cancel-button-text="$t('app.common.cancel')"
                :confirm-button-text="$t('app.common.confirm')"
                type="date"
                :title="$t('app.deal_inquiry.select_date')"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="5" class="rowStyleBtn" style="text-align: center"
          ><van-button
            type="danger"
            size="small"
            style="height: 30px"
            @click="getDeal"
            >{{$t("app.deal_inquiry.search")}}</van-button
          ></van-col
        >
      </van-row>
      <van-row class="details"
        ><van-col span="12" class="rowStyle"
          ><p>
            {{$t("app.deal_inquiry.buy")}} $<span>{{ totalbuy.toFixed(2) }}</span>
          </p></van-col
        >
        <van-col span="12" class="rowStyle"
          ><p>
            {{$t("app.deal_inquiry.sell")}} $<span>{{ totalsell.toFixed(2) }}</span>
          </p></van-col
        >
      </van-row>
    </div>
    <div class="tableContent">
      <div class="tableheading" style="font-size: 14px">
        <table class="stockTable" cellspacing="0" cellpadding="0" border="0">
          <tr>
            <th>{{$t("app.deal_inquiry.name")}}</th>
            <th>{{$t("app.deal_inquiry.direction")}}</th>
            <th>{{$t("app.deal_inquiry.qty")}}</th>
            <th>{{$t("app.deal_inquiry.price")}}</th>
            <th>{{$t("app.deal_inquiry.amount")}}</th>
            <th>{{$t("app.deal_inquiry.commision")}}</th>
            <th>{{$t("app.deal_inquiry.stamp")}}</th>
            <th>{{$t("app.deal_inquiry.levy")}}</th>
            <th>{{$t("app.deal_inquiry.fees")}}</th>
            <th>{{$t("app.deal_inquiry.delivery")}}</th>
            <th>{{$t("app.deal_inquiry.pltFee")}}</th>
            <th>{{$t("app.trading.trading_activity_fee")}}</th>
            <th>{{$t("app.deal_inquiry.frc")}}</th>
            <th>{{$t("app.deal_inquiry.directionTrade")}}</th>
            <th>{{$t("app.deal_inquiry.time")}}</th>
          </tr>
        </table>
      </div>
      <div class="tabledata">
        <van-list
          v-model="loadingDeal"
          :finished="finishedDeal"
          :finished-text="$t('app.common.finished')"
        >
          <table class="stockTable" cellspacing="0" cellpadding="0" border="0">
            <tr
              class="stock_td"
              v-for="(item, index) in unwindData"
              :key="index"
            >
              <td>
                <p>
                  <span>{{
                    item.name.length >= 4
                      ? item.name.substr(0, 4) + "..."
                      : item.name
                  }}</span
                  ><br /><span>{{ item.code_new }}</span>
                </p>
              </td>
              <td>
                <p v-bind:style="item.isBuy == 0 ? 'color:green' : 'color:red'">
                  {{ item.type }}
                </p>
              </td>
              <td>
                <p>{{ item.number }}</p>
              </td>
              <td>
                <p>{{ parseFloat(item.price).toFixed(3) }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.total }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.commission }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.stamp }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.change }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.extra_fee1 }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.extra_fee2 }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.extra_fee3 }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.transaction }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.chj_levy }}</p>
              </td>
              <td>
                <p>{{ item.direction }}</p>
              </td>
              <td>
                <p>{{ $getDeviceTime(item.time) }}</p>
              </td>
            </tr>
          </table>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DealInquiry",
  data() {
    return {
      date: new Date(),
      startStatus: false,
      startDate: this.$moment().format("YYYY-MM-DD"),
      endStatus: false,
      endDate: this.$moment().format("YYYY-MM-DD"),
      unwindData: [],
      totalbuy: 0,
      totalsell: 0,
      loadingDeal: false,
      finishedDeal: false,
    };
  },

  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getUnwindData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "all_deal",
            token: window.sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            let entrust = resData.data;
            let unwindData = [];
            for (let i = 0, len = entrust.length; i < len; i++) {
              if (entrust[i].depot_mold === 1) {
                unwindData.push(entrust[i]);
                that.totalbuy = that.totalbuy + parseFloat(entrust[i].total);
              } else {
                that.totalsell = that.totalsell + parseFloat(entrust[i].total);
              }
            }
            //that.unwindData = unwindData;
          } else if (resData.code == 0 || resData.code == -1) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        });
    },
    getDeal() {
      let that = this;
        let data = {
           nozzle: "all_deal",
            token: window.sessionStorage.getItem("token"),
            };
         if (that.startDate) {
    data.start = that.$moment(that.startDate)
      .startOf('day')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  }
  if (that.endDate) {
    data.end = that.$moment(that.endDate)
      .endOf('day')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  }
      that
        .$http({
          url: "/",
          method: "post",
          data: data,
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.unwindData = resData.data;
            that.loadingDeal = false;
            that.finishedDeal = true;
          } else if (resData.code == 0 || resData.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        })
        .catch(() => {
          that.loadingDeal = false;
          that.finishedDeal = true;
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },
    onConfirmStartDate(time) {
      this.startDate = this.$moment(time).format("YYYY-MM-DD");
      this.startStatus = false;
    },
    onConfirmEndDate(time) {
      this.endDate = this.$moment(time).format("YYYY-MM-DD");
      this.endStatus = false;
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    that.getUnwindData();
    that.getDeal();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.topContent {
  /* height: 125px; */
  background: #ffffff;
  /* position: fixed;
  top: 42px;
  left: 0;
  width: 100%; */
}

.dateFilter {
  padding: 10px 5px;
  /* position: fixed;
  top: 56px;
  left: 0;
  width: 100%; */
  /* border-bottom: 1px solid #ebedf0; */
  /* padding-bottom: 10px; */
}

.rowStyle {
  height: 30px;
  line-height: 30px;
}

.calanderStyle {
  border: 1px solid #969799;
}

.rowStyleBtn {
  line-height: 20px;
}

.tableheading {
  font-size: 14px;
  /* position: sticky;
  top: 140px; */
  padding-bottom: 10px;
  text-align: center;
  /* width: 100%; */
  width: 1000px;
}

.tabledata {
  font-size: 14px;
  /* margin-top: 145px; */
}

.details {
  /* position: fixed;
  top: 110px;
  left: 0;
  width: 100%; */
  padding-bottom: 10px;
  text-align: center;
}

.details p {
  line-height: 20px;
  margin: 0;
}

.rowData {
  border-bottom: 1px solid rgb(235, 237, 240);
  padding: 10px 0px;
}

.stockTable {
  text-align: left;
  width: 1000px;
}

.stockTable p {
  margin: 3px 0px;
}

.stockTable th,
.stockTable td {
  width: 80px;
  text-align: center;
}

.tableContent {
  /* margin-top: 10px; */
  overflow-y: hidden;
  overflow-x: scroll;
  width: 100vw;
}
</style>


// WEBPACK FOOTER //
// src/components/DealInquiry.vue